import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/LandingPage/Advert/Advert.css';

export default function Advert() {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!sessionStorage.getItem('actyra-valuation-engine-advert-closed')) {
      const timer = setTimeout(() => { setIsOpen(true); requestAnimationFrame(() => setIsVisible(true)); }, 1100);
      return () => clearTimeout(timer);
    }
  }, []);

  const close = () => {
    setIsVisible(false);
    sessionStorage.setItem('actyra-valuation-engine-advert-closed', 'true');
    setTimeout(() => setIsOpen(false), 420);
  };

  const openEngine = (anchor = '') => { close(); navigate(`/valuation-engine${anchor}`); };
  if (!isOpen) return null;

  return (
    <div className={`bp-advert-overlay ${isVisible ? 'is-open' : ''}`} onClick={close}>
      <div className={`bp-advert-modal ${isVisible ? 'is-visible' : ''}`} onClick={(event) => event.stopPropagation()} role="dialog" aria-modal="true" aria-labelledby="engine-advert-title">
        <div className="bp-ambient" aria-hidden="true"><i/><i/><i/></div>
        <button className="bp-close" onClick={close} aria-label="Close Valuation Engine announcement">×</button>
        <div className="bp-visual">
          <div className="bp-window">
            <div className="bp-window-top"><span className="bp-mark"><img src="/Main Logo.png" alt="Actyra" /></span><b>Valuation workspace</b><em><i/> Model run</em></div>
            <div className="bp-window-body">
              <aside><b>Overview</b><span>Data</span><span>Assumptions</span><span>Scenarios</span></aside>
              <main><small>BEST ESTIMATE LIABILITY</small><h3>KES 4.82B <em>+2.4%</em></h3><div className="bp-bars">{[28,45,38,62,54,74,68,92].map((height,index)=><i key={index} style={{height:`${height}%`}}/>)}</div><footer><span>✓ Data validated</span><span>✓ Scenarios compared</span></footer></main>
            </div>
          </div>
          <div className="bp-float"><strong>↗</strong><div><b>12 scenarios</b><small>Side-by-side analysis</small></div></div>
          <div className="bp-flow"><span><b>01</b> Data</span><i>→</i><span><b>02</b> Model</span><i>→</i><span><b>03</b> Decision</span></div>
        </div>
        <div className="bp-content">
          <div className="bp-eyebrow"><i/> Life &amp; General Insurance</div>
          <h2 id="engine-advert-title">Meet the Actyra<br/><span>Valuation Engine.</span></h2>
          <p>Model products, value portfolios, calculate reserves, run pricing tests and report results in one actuarial workflow.</p>
          <div className="bp-points">
            <div><span>⌁</span><p><b>Life valuation &amp; pricing</b><small>BEL, IFRS 17, statutory provisions and profit testing.</small></p></div>
            <div><span>⌗</span><p><b>General Insurance reserving</b><small>IBNR through Chain Ladder, BF and Cape Cod; premium UPR.</small></p></div>
            <div><span>↗</span><p><b>Portfolio reporting</b><small>Policy and portfolio-level outputs from one workflow.</small></p></div>
          </div>
          <div className="bp-actions"><button onClick={() => openEngine()}>Explore the tool <b>↗</b></button><button onClick={() => openEngine('#book-demo')}>Book a demo →</button></div>
          <button className="bp-dismiss" onClick={close}>Not right now</button>
        </div>
      </div>
    </div>
  );
}
